import { StandardEvents } from '@shopify/events';

const bar = document.getElementById('tcv-sticky-cart');
if (bar) {
  const countNode = bar.querySelector('[data-tcv-sticky-count]');
  const itemsNode = bar.querySelector('[data-tcv-sticky-items]');
  const subtotalNode = bar.querySelector('[data-tcv-sticky-subtotal]');
  const viewCart = bar.querySelector('[data-tcv-view-cart]');
  const cartUrl = bar.dataset.cartUrl;
  const cartPageUrl = bar.dataset.cartPageUrl;
  const currency = bar.dataset.currency || 'USD';
  let requestVersion = 0;

  const formatPrice = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
      }).format(cents / 100);
    } catch {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  const render = (cart) => {
    const count = Math.max(0, Number(cart.item_count ?? cart.totalQuantity ?? 0));
    const subtotal = Number(cart.total_price ?? 0);
    if (countNode) countNode.textContent = String(count);
    if (itemsNode) itemsNode.textContent = count === 1 ? 'ITEM' : 'ITEMS';
    if (subtotalNode) subtotalNode.textContent = formatPrice(subtotal);
    const cartPagePath = new URL(cartPageUrl || '/cart', window.location.origin).pathname.replace(/[/]$/, '');
    const currentPath = window.location.pathname.replace(/[/]$/, '');
    const shouldShow = count > 0 && currentPath !== cartPagePath;
    bar.hidden = !shouldShow;
    document.documentElement.classList.toggle('tcv-sticky-cart-visible', shouldShow);
  };

  const refresh = async () => {
    const version = ++requestVersion;
    try {
      const response = await fetch(cartUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (version !== requestVersion) return;
      render(cart);
    } catch (error) {
      console.warn('[TCV sticky cart] Could not refresh cart.', error);
    }
  };

  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    const settled = event.promise;
    if (settled && typeof settled.then === 'function') {
      settled.then(refresh).catch(refresh);
    } else {
      refresh();
    }
  });

  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refresh();
  });

  viewCart?.addEventListener('click', () => {
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else {
      window.location.assign(cartPageUrl || '/cart');
    }
  });

  refresh();
}
